import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['firstInput', 'multiSelect']
  static values = { allowNewChoices: Boolean }

  connect () {
    // Show modal when connected
    if (this.element.tagName === 'DIALOG' && !this.element.open) {
      this.element.showModal()
    }

    // Initialize Choices.js for multi-select fields
    this.initializeChoices()

    // Focus first input if present
    this.focusFirstInput()
  }

  disconnect () {
    // Cleanup Choices instances
    this.cleanupChoices()

    // Close dialog when disconnected (turbo frame cleared)
    if (this.element.tagName === 'DIALOG' && this.element.open) {
      this.element.close()
    }
  }

  initializeChoices () {
    // Store Choices instances for cleanup
    this.choicesInstances = []

    // Initialize Choices.js for all multiSelect targets
    if (typeof Choices !== 'undefined' && this.hasMultiSelectTarget) {
      this.multiSelectTargets.forEach(select => {
        // Check if Choices is not already initialized on this element
        if (!select.classList.contains('choices__input')) {
          const config = {
            removeItemButton: true,
            removeItemIconText: '', // Remove default data URL icon
            searchEnabled: true,
            searchPlaceholderValue: 'Rechercher...',
            noResultsText: 'Aucun résultat trouvé',
            noChoicesText: 'Aucun choix disponible',
            itemSelectText: 'Cliquer pour sélectionner'
          }

          // Allow adding new choices if enabled
          if (this.allowNewChoicesValue) {
            config.addItems = true
            config.addChoices = true
            config.editItems = true
            config.removeItems = true
            config.duplicateItemsAllowed = false
            config.addItemText = (value) => `Ajouter "<b>${value}</b>" comme nouveau rôle`
          }

          const choicesInstance = new Choices(select, config)
          this.choicesInstances.push(choicesInstance)
        }
      })
    }
  }

  cleanupChoices () {
    // Destroy all Choices instances
    if (this.choicesInstances) {
      this.choicesInstances.forEach(instance => {
        if (instance && typeof instance.destroy === 'function') {
          instance.destroy()
        }
      })
      this.choicesInstances = []
    }
  }

  focusFirstInput () {
    // Focus and select first input
    if (this.hasFirstInputTarget) {
      setTimeout(() => {
        this.firstInputTarget.focus()
        this.firstInputTarget.select()
      }, 100)
    }
  }

  close (event) {
    if (event) {
      event.preventDefault()
    }

    if (this.element.tagName === 'DIALOG') {
      this.element.close()

      // Remove the turbo frame content
      const modalFrame = document.getElementById('modal')
      if (modalFrame) {
        modalFrame.innerHTML = ''
      }
    }
  }

  // Close dialog when clicking outside
  clickOutside (event) {
    if (event.target === this.element) {
      this.close(event)
    }
  }
}
